import React, { useEffect } from "react";
import { Form } from "@redriver/cinnamon";
import {
  ClientAgreementsTypeAheadLookup,
  AgreementSchedulesTypeAheadLookup,
  SheetsTypeAheadLookup,
} from "features/../../../shared/features/Settings/lookups";
import { ClientsDropdownLookup } from "features/Clients/lookups";
import { TranslatedModal } from "features/../../../shared/components/modals";

const FROM_TEMPLATE = "fromTemplate";

const DuplicateFromTemplateModalContent = ({
  modalProps,
  formProps,
  templateClients,
  dealerOfficeId,
  t,
}) => {
  const {
    duplicateOption,
    templateClientId,
    templateAgreementId,
    templateScheduleId,
  } = formProps.value;

  const singleTemplateClient =
    templateClients && templateClients.length === 1 ? templateClients[0] : null;

  useEffect(() => {
    if (singleTemplateClient && !templateClientId) {
      formProps.onChange({ templateClientId: singleTemplateClient.id });
    }
  }, [singleTemplateClient, templateClientId, formProps]);

  const submitDisabled =
    duplicateOption === FROM_TEMPLATE &&
    (!templateClientId ||
      !templateAgreementId ||
      !templateScheduleId ||
      !formProps.value.templateSheetId);

  return (
    <TranslatedModal.Confirmation
      {...modalProps}
      header={t("HeaderText")}
      submitLabel={t("SubmitLabel")}
      submitDisabled={submitDisabled}
    >
      <Form {...formProps}>
        <div className="agreement-radio-buttons">
          <Form.RadioGroup
            field="duplicateOption"
            label={t("ChooseOption")}
            options={[
              { value: "blank", text: t("BlankSheet") },
              { value: FROM_TEMPLATE, text: t("DuplicateFromTemplate") },
            ]}
          />
        </div>

        <Form.If
          condition={({ fields }) => fields.duplicateOption === FROM_TEMPLATE}
        >
          <Form.Trigger
            field="templateClientId"
            event="onChange"
            action="clear"
            target="templateAgreementId"
          />
          <Form.Trigger
            field="templateClientId"
            event="onChange"
            action="clear"
            target="templateScheduleId"
          />
          <Form.Trigger
            field="templateClientId"
            event="onChange"
            action="clear"
            target="templateSheetId"
          />
          <Form.Trigger
            field="templateAgreementId"
            event="onChange"
            action="clear"
            target="templateScheduleId"
          />
          <Form.Trigger
            field="templateAgreementId"
            event="onChange"
            action="clear"
            target="templateSheetId"
          />
          <Form.Trigger
            field="templateScheduleId"
            event="onChange"
            action="clear"
            target="templateSheetId"
          />

          <ClientsDropdownLookup
            field="templateClientId"
            textField="templateClientName"
            label={t("TemplateCustomer")}
            dealerOfficeId={dealerOfficeId}
            isTemplate={true}
            required
            placeholder={t("SelectTemplateCustomer")}
            onKeyDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          />

          {templateClientId && (
            <ClientAgreementsTypeAheadLookup
              className="move-sheet-margin"
              field="templateAgreementId"
              textField="templateAgreementName"
              label={t("Agreement")}
              clientId={templateClientId}
              required
              placeholder={t("SelectAgreement")}
              clearable
              search
              onKeyDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
            />
          )}

          {templateAgreementId && (
            <AgreementSchedulesTypeAheadLookup
              className="move-sheet-margin"
              field="templateScheduleId"
              textField="templateScheduleName"
              label={t("Schedule")}
              agreementId={templateAgreementId}
              required
              placeholder={t("SelectSchedule")}
              clearable
              search
              disabled={!templateAgreementId}
              onKeyDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
            />
          )}

          {templateScheduleId && (
            <SheetsTypeAheadLookup
              className="move-sheet-margin"
              field="templateSheetId"
              textField="templateSheetName"
              label={t("Sheet")}
              scheduleId={templateScheduleId}
              required
              placeholder={t("SelectSheet")}
              clearable
              search
              disabled={!templateScheduleId}
              onKeyDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              lookupOptions={{ cache: false }}
            />
          )}
        </Form.If>
      </Form>
    </TranslatedModal.Confirmation>
  );
};

export default DuplicateFromTemplateModalContent;
